// Module
var code = `<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: cancel" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <h4 class="modal-title">Backup Now</h4>
        </div>
        <div class="modal-body">
            <div>
                Please select backup type
            </div>
        </div>
        <div class="modal-footer">
            <div class="text-right">
                <button data-bind="click: fullBackup, attr: { 'title': fullBackupType }" type="button" class="btn btn-success">
                    <i class="icon-backups"></i><span data-bind="text: fullBackupType"></span>
                </button>
                <button data-bind="click: incrementalBackup" type="button" class="btn btn-info" title="Incremental Backup">
                    <i class="icon-backups"></i><span>Incremental Backup</span>
                </button>
                <button type="button" class="btn btn-default" data-bind="click: cancel"><i class="icon-cancel">
                </i><span>Cancel</span></button>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;